<template>
  <main>
    <v-dialog
      :value="dialog"
      :max-width="1000"
      @input="$emit('update:dialog')"
      scrollable
    >
      <v-card class="orders" max-width="1000px" v-if="!loading">
        <v-card-title class="py-0 justify-center">
          <span class="secondary--text font-bold pt-2">
            {{ $t("order_details") }}</span
          >
        </v-card-title>
        <v-card-subtitle class="mt-1">
          <h3 class="text-center primary--text">
            {{ package_order.package_name }}
          </h3>
        </v-card-subtitle>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" lg="8">
                <v-row>
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("invoice_and_detials") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col cols="12">
                    <v-card flat class="orders__invoice">
                      <v-container>
                        <v-row class="px-2">
                          <v-col cols="12" lg="6">
                            <span class="secondary--text size-16 weight-800">
                              {{ $t("table.package_date") }}
                            </span>
                          </v-col>
                          <v-col
                            cols="12"
                            lg="6"
                            class="d-flex justify-center justify-sm-end"
                          >
                            <span class="secondary--text size-16 weight-800">
                              {{ convertDateAndTime(package_order.starts_at) }}
                            </span>
                          </v-col>
                          <v-col
                            cols="12"
                            v-for="(item, index) in package_order.items"
                            :key="index"
                          >
                            <v-row>
                              <v-col
                                cols="12"
                                lg="6"
                                class="d-flex algin-center"
                              >
                                <div
                                  class="
                                    secondary--text
                                    size-16
                                    weight-800
                                    d-flex
                                    align-center
                                  "
                                >
                                  <div
                                    class="d-flex align-center"
                                    style="min-width: 30px"
                                  >
                                    {{ `${item.qty} X` }}
                                  </div>
                                  <div>
                                    {{
                                      ` ${item.package_option_name} (${
                                        item.package_option_children_count
                                      } ${$t("children")} - ${
                                        item.package_option_persons_count
                                      } ${$t("persons")})`
                                    }}
                                  </div>
                                </div>
                              </v-col>
                              <v-col
                                cols="12"
                                lg="6"
                                class="
                                  d-flex
                                  justify-center justify-sm-end
                                  align-self-center
                                "
                              >
                                <span class="primary--text size-16 weight-800">
                                  {{ item.grand_total | transformCurrency }}
                                </span>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions class="px-2 mx-0 d-flex flex-wrap">
                        <v-col
                          cols="12"
                          lg="6"
                          class="align-self-center d-flex"
                        >
                          <span class="error--text size-16 weight-800">
                            {{ $t("table.total_price") }}
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          lg="6"
                          class="d-flex justify-center justify-sm-end"
                        >
                          <span class="error--text size-16 weight-800">
                            {{ package_order.sub_total | transformCurrency }}
                          </span>

                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                class="px-2"
                                color="#a5a5a5"
                                dark
                                v-bind="attrs"
                                v-on="on"
                              >
                                mdi-help-circle
                              </v-icon>
                            </template>
                            <span>Tooltip</span>
                          </v-tooltip> -->
                        </v-col>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- special order -->
                <v-row v-if="package_order.over_prices.length > 0">
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("special_order") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col cols="12">
                    <v-card flat class="orders__invoice">
                      <v-container>
                        <v-row
                          v-for="(over_price,
                          index) in package_order.over_prices"
                          :key="index"
                        >
                          <v-col
                            cols="12"
                            lg="6"
                            class="align-self-center d-flex"
                          >
                            <span class="secondary--text size-16 weight-800">
                              {{ over_price.reason }}
                            </span>
                          </v-col>
                          <v-col cols="12" lg="6" class="py-0">
                            <v-list flat class="transparent pa-0 mx-0">
                              <v-list-item class="px-0">
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <span
                                      class="primary--text size-16 weight-800"
                                    >
                                      {{ over_price.value | transformCurrency }}
                                    </span>
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions class="px-0 mx-0 d-flex flex-wrap">
                        <v-col
                          cols="12"
                          lg="6"
                          class="align-self-center d-flex"
                        >
                          <span class="error--text size-16 weight-800">
                            {{ $t("table.total_price") }}
                          </span>
                        </v-col>
                        <v-col cols="12" lg="6" class="py-0">
                          <v-list flat class="transparent pa-0 mx-0">
                            <v-list-item class="px-0">
                              <v-list-item-content>
                                <v-list-item-title>
                                  <span class="error--text size-16 weight-800">
                                    {{
                                      package_order.grand_total
                                        | transformCurrency
                                    }}
                                  </span>
                                </v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-icon>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon
                                      color="#a5a5a5"
                                      dark
                                      v-bind="attrs"
                                      v-on="on"
                                    >
                                      mdi-help-circle
                                    </v-icon>
                                  </template>
                                  <span>Tooltip</span>
                                </v-tooltip>
                              </v-list-item-icon>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
                <!-- order details -->
                <v-row v-if="package_order.package">
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("package_details") }}
                      </span>
                    </v-chip>
                  </v-col>
                  <v-col cols="12">
                    <v-card flat class="orders__invoice">
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            <v-row>
                              <v-col cols="12" lg="6">
                                <h3 class="secondary--text">
                                  {{
                                    package_order.package &&
                                      package_order.package.name
                                  }}
                                </h3>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="12"
                            v-if="
                              package_order.package &&
                                package_order.package.media
                            "
                          >
                            <v-card class="orders__media-card" v-if="dialog">
                              <MediaSlider
                                :items="package_order.package.media"
                              />
                            </v-card>
                          </v-col>
                          <v-col cols="12">
                            <div class="d-flex align-center">
                              <img
                                width="16px"
                                height="16px"
                                :src="require('@/assets/imgs/price.svg')"
                                alt="photo"
                              />
                              <div
                                class="px-2"
                                style="font-size: 12px; font-weight: 600"
                              >
                                <span class="secondary--text">
                                  {{ $t("price_start") }}
                                  {{ $t("from") }}
                                </span>
                                <span class="primary--text font-bold">
                                  {{
                                    package_order.package.min_person_price
                                      | transformCurrency
                                  }}
                                  :
                                  {{
                                    package_order.package.max_person_price
                                      | transformCurrency
                                  }}
                                </span>
                              </div>
                            </div>
                          </v-col>
                               <v-col cols="12" lg="6">
                          <div class="d-flex align-center">
                          
                            <span class="px-2">
                              {{ $t("starts_at") }}
                            </span>
                            <span class="primary--text font-bold">
                              {{
                               package_order && new Date(package_order.starts_at).toLocaleString()
                              }}
                            </span>
                          </div>
                        </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
                <user-details :userDetails="package_order.user" v-if="Object.keys(package_order.user).length" />
              </v-col>
              <v-col cols="12" lg="4">
                <v-row>
                  <v-col cols="12" lg="3">
                    <v-chip class="error orders__title">
                      <span class="white--text font-bold">
                        {{ $t("order_status") }}
                      </span>
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="d-flex flex-column">
                    <v-row>
                      <v-col cols="12">
                        <OrderStatus :item="package_order" />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" class="align-self-end">
                        <v-row>
                          <v-col cols="12" class="align-self-end">
                            <v-row>
                              <v-col cols="12">
                                <v-btn
                                  depressed
                                  block
                                  large
                                  class="primary"
                                  :disabled="package_order.accepted"
                                  @click="handleAcceptOrder"
                                >
                                  <span class="white--text font-bold">
                                    {{ $t("accept") }}
                                  </span>
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <template v-if="package_order.has_special_request">
                <v-col cols="12" lg="3">
                  <v-chip class="error orders__title">
                    <span class="white--text font-bold">
                      {{ $t("special_order") }}
                    </span>
                  </v-chip>
                </v-col>
                <v-col>
                  <p>{{ package_order.special_request_details }}</p>
                </v-col>
              </template>
              <v-col cols="12" v-if="package_order.has_special_request">
                <overPrices :order="package_order" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
      <v-card min-height="200px" max-width="1000px" v-else>
        <loader class="h-100" />
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import { IndexData, StoreData } from "@/helpers/apiMethods";

export default {
  name: "PackagesOrder",
  components: {
    OrderStatus: () => import("./Status.vue"),
    overPrices: () => import("./overPrices.vue"),
    UserDetails: () => import("../sharedCmp/userDetails.vue")
  },
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      package_order: {},
      loading: true
    };
  },
  methods: {
    handleAcceptOrder() {
      const formData = new FormData();
      formData.append("_method", "put");
      formData.append("accept", 1);
      this.popUp().then(value => {
        if (!value.dismiss) {
          StoreData({
            reqName: `package-orders/${this.package_order.reference_number}`,
            data: formData
          })
            .then(() => {
              this.$emit("update:dialog");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    handleCancel() {
      this.popUp().then(res => {
        if (!res.dismiss) {
          StoreData({
            reqName: `package-orders/${this.item.reference_number}`,
            data: { _method: "delete" }
          }).then(() => {
            this.$emit("update:dialog");
            this.$emit("refresh");
          });
        }
      });
    },

    handleShow() {
      IndexData({ reqName: `package-orders/${this.item.reference_number}` })
        .then(res => {
          const { package_order } = res.data;
          this.package_order = package_order;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (value) {
          this.handleShow();
        } else {
          this.loading = true;
          this.$emit("refresh-table");
        }
      },
      immediate: true
    }
  }
};
</script>
